import { validationEncoder } from 'affiny-core/modules/api/models/registration/registration.serializer';
import { IValidationPasswordFormValues } from 'affiny-core/modules/api/repositories/validationPassword/validationPassword.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const ValidationPasswordResource = {
  validateField: (values: Partial<IValidationPasswordFormValues>) =>
    AffinyEndpoint.ValidationPassword.url(`/`)
      .post({
        data: validationEncoder(values),
      })
      .res(),
};
